import React from 'react'

import { Tooltip } from 'antd'
import Flex from 'components/Flex'
import moment from 'moment'
import { COLORS } from 'theme'
import { CardText, CardValue, SingleCard, SubText, TopHeader } from './style'

const InfoCards = ({
  background = COLORS.BLUE_T_95,
  padding = '15px 25px',
  width = 'auto',
  height,
  state,
  current,
  activeCard,
  setActiveCard,
  id,
  date,
  count,
  title = 'Interview scheduled',
  setSelectedDate,
  isRole = false,
  isSetData = false,
  isDate = false,
  Item,
  setCurrentSelection,
  setCurrentTimeDetails,
  setSelectedTime,
  setFromDate,
  fromDate,
  setActiveTime,
}) => {
  const clickedFn = id => {
    setActiveCard(id)
    if (isSetData) {
      const formattedDate = moment(Item?.date).format('YYYY-MM-DD')?.toString()
      setSelectedDate(formattedDate)
    }
    if (isRole) {
      setActiveTime(0)
      setCurrentSelection(Item)
      setCurrentTimeDetails(Item?.panelList?.[0])
      setSelectedTime(Item?.panelList?.[0])
    }
    if (isDate) {
      const formattedDate = moment(Item?.date).format('YYYY-MM-DD')?.toString()
      setFromDate(formattedDate)
    }
  }
  const formatWithSup = date => {
    return moment(date)
      .format('Do MMM, YYYY')
      .replace(/(\d+)(st|nd|rd|th)/g, '$1<sup>$2</sup>')
  }
  let formattedDate

  if (!isRole) {
    formattedDate = (
      <span dangerouslySetInnerHTML={{ __html: formatWithSup(date) }} />
    )
  } else if (date?.length > 13) {
    formattedDate = <Tooltip title={date}>{date.slice(0, 13) + '...'}</Tooltip>
  } else {
    formattedDate = date
  }
  return (
    <SingleCard
      onClick={() => clickedFn(id)}
      background={current && state == current ? COLORS.BLUE_T_80 : background}
      padding={padding}
      width={width}
      column
      flexStart
      height={height}
      styleProps={
        (activeCard === id && isRole) ||
        (fromDate === moment(Item?.date).format('YYYY-MM-DD')?.toString() &&
          !isRole)
      }
    >
      <CardText>
        {title?.length > 20 ? (
          <Tooltip title={title}>{title.slice(0, 20) + '...'}</Tooltip>
        ) : (
          title
        )}
      </CardText>
      <CardValue>{formattedDate}</CardValue>
      <TopHeader row spaceBetween alignCenter>
        <Flex row flexStart>
          <CardValue>{count}</CardValue>
          <SubText>Candidates</SubText>
        </Flex>
      </TopHeader>
    </SingleCard>
  )
}

export default InfoCards
